<template>
    <div class="card-gray mx-auto rounded shadow py-4 px-6 w-72 max-w-full">
        <div class="block">
            <div class="text-center mb-2">
                <div class="mb-1">
                    <p class="text-4lg font-bold">
                        {{ hours }} Hours
                    </p>
                    <p class="text-sm">
                        {{ title }}
                    </p>
                </div>
            </div>
            <div class="flex justify-between items-center">
                <PricePerMonth
                    size="small"
                    :price="priceToShow"
                    :note="quantity > 0 ? null : priceNote"
                    :showPlus="false"
                />
                <button
                    v-if="ctaType === 'button'"
                    type="button"
                    class="buyflow-button text-sm"
                    :class="{
                        'active': ctaButtonIsSelected,
                        'compressed': ctaButtonMini,
                    }"
                    :disabled="!hasSelectedAService"
                    @click="ctaButtonIsSelected? $emit('deselect'): $emit('select')">

                    <template v-if="ctaButtonIsSelected">
                        <IconCheck class="inline mr-1" />
                        {{ ctaButtonTextSelected }}
                    </template>
                    <template v-else>
                        {{ ctaButtonText }}
                    </template>

                </button>
                <div v-if="ctaType === 'dropdown'"
                    class="buyflow-numeric-select"
                    :class="{ 'active': quantity > 0 }">
                    <select @change="quantityChanged"
                            v-model="quantity"
                            class="edge">
                        <option v-for="(item, index) in new Array(ctaDropdownMax + 1)"
                                :key="index"
                                :value="index">
                            {{ index }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PricePerMonth from "@/atoms/PricePerMonth"
    import IconCheck from "@/atoms/icons/IconCheck"
    import IconCircleExclamation from "@/atoms/icons/IconCircleExclamation"

    export default {
        name: 'Card',
        components: {
            PricePerMonth,
            IconCheck,
            IconCircleExclamation
        },
        props: {
            hasSelectedAService: {
                type: Boolean,
                default: false,
            },
            upgradeType: {
                type: String,
                required: true,
                default: null,
            },
            title: {
                type: String,
                required: true,
                default: null,
            },
            hours: {
                type: String,
                default: "300",
            },
            price: {
                type: Number,
                required: true,
                default: 0,
            },
            priceNote: {
                type: String,
                default: null,
            },
            ctaType: {
                type: String,
                required: true,
                default: 'button',
                validator: val => [
                    'button',
                    'dropdown',
                ].includes(val)
            },
            ctaButtonText: {
                type: String,
                default: 'Select',
            },
            ctaButtonTextSelected: {
                type: String,
                default: 'Selected',
            },
            ctaButtonMini: {
                type: Boolean,
                default: true,
            },
            ctaButtonIsSelected: {
                type: Boolean,
                default: false,
            },
            ctaButtonAllowDeselect: {
                type: Boolean,
                default: false,
            },
            ctaDropdownValue: {
                type: Number,
                default: 0,
            },
            ctaDropdownMax: {
                type: Number,
                default: 1,
            },

        },
        data: () => ({
            quantity: 0,
        }),
        computed: {
            priceToShow () {
                return this.quantity > 0 ? this.quantity * this.price : this.price
            },
            ctaButtonIsDisabled() {
                return this.ctaButtonIsSelected && !this.ctaButtonAllowDeselect
            },
        },
        mounted() {
            this.quantity = this.ctaDropdownValue
        },
        methods: {
            quantityChanged() {
                this.$emit('cta-dropdown-changed', this.quantity)
            },
        },
    }
</script>
